import { Layout } from 'antd';
import React from 'react';
import { RouterProps, withRouter } from 'react-router';
import styled from 'styled-components';
import { Header } from '../layout/containers/main-header.container';
import ManagementPanel from '../management/management-panel.component';
const { Content } = Layout;

const StyledLayout = styled(Layout)`
  height: 100%;

  .ant-layout-header {
    height: 48px;
    line-height: 48px;
  }
`;

export const ManagePage: React.SFC<RouterProps> = () => (
  <StyledLayout>
    <Header />
    <Content>
      <ManagementPanel />
    </Content>
  </StyledLayout>
);

export default withRouter(ManagePage);
